module.exports = __webpack_public_path__ + "img/star.dcb2809d.svg";